<template>
  <div>
    <!-- 分配 -->
    <el-dialog :title="$t('message.CWGroupBatchOperation')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="600px" center>
      <div class="content">
        <div class="row">
          <!--  操作类型： -->
          <div class="label">
            {{ $t("message.operationType") }}:
          </div>
          <div class="value">
            <el-radio-group v-model="type">
              <!-- 拉人 -->
              <el-radio label="10"> {{ $t("message.pullPeople") }}</el-radio>
              <!--踢人  -->
              <el-radio label="20"> {{ $t("message.kickOut") }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!--选择客户聊天群组  -->
        <div class="item">
          <!-- 选择客户聊天群组 -->
          <el-button type="primary" @click="chooseCWGroup">{{ $t("message.chooseCustomerChatGroup") }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 客户ID -->
            <li>
              {{ $t("message.clientID") }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ $t("message.customerName") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <ul v-for="(item, index) in user" :key="item.id">
            <!-- 客户ID -->
            <li>
              {{ item.id }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ item.realname }}
            </li>
            <!-- 操作 -->
            <li>
              <!-- 删除 -->
              <el-button type="danger" @click="user.splice(index, 1)" size="mini">{{ $t("message.delete")
              }}</el-button>
            </li>
          </ul>
        </div>
        <!--选择人员  -->
        <div class="item">
          <!-- 选择人员 -->
          <el-button type="primary" @click="chooseUser">{{ $t("message.chooseUser") }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 业务账号 -->
            <li>
              {{ $t("message.accountNumber") }}
            </li>
            <!-- 业务名称 -->
            <li>
              {{ $t("message.adminName") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}

            </li>
          </ol>
          <ul v-for="(item, index) in admin" :key="item.id">
            <!-- 客户ID -->
            <li>
              {{ item.username }}
            </li>
            <!-- 业务名称 -->
            <li>
              {{ item.realname }}
            </li>
            <!-- 操作 -->
            <li>
              <!-- 删除 -->
              <el-button type="danger" @click="realnameList.splice(index, 1)" size="mini">{{ $t("message.delete")
              }}</el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确认操作 -->
        <el-button type="primary" @click="modifyingGroup">{{
          $t("message.confirmOperation")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择客户聊天群组 -->
    <el-dialog :title="$t('message.chooseCustomerChatGroup')" :close-on-click-modal="false"
      :visible.sync="chooseCWGroupDialogVisible" width="500px" center>
      <div class="content">
        <div class="row">
          <!--  操作类型： -->
          <div class="value">
            <el-input v-model="clientID" :placeholder="$t('message.clientID')"></el-input>
          </div>
          <!-- 查询 -->
          <el-button type="primary" @click="chooseCWGroupSave" style="margin-left: 10px;">{{
            $t("message.inquire")
          }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 客户ID -->
            <li>
              {{ $t("message.clientID") }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ $t("message.customerName") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <ul v-for="(item, index) in clientList" :key="item.id">
            <!-- 客户ID -->
            <li>
              {{ item.id }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ item.realname }}
            </li>
            <!-- 操作 -->
            <li>
              <!-- 删除 -->
              <el-button type="danger" @click="clientList.splice(index, 1)" size="mini">{{ $t("message.delete")
              }}</el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确认 -->
        <el-button type="primary" @click="confirmUser">{{
          $t("message.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择人员 -->
    <el-dialog :title="$t('message.chooseUser')" :close-on-click-modal="false" :visible.sync="chooseUserDialogVisible"
      width="500px" center>
      <div class="content">
        <div class="row">
          <!--  操作类型： -->
          <div class="value">
            <!-- 业务员名字 -->
            <el-input v-model="realname" :placeholder="$t('message.adminName')"></el-input>
          </div>
          <!-- 查询 -->
          <el-button type="primary" @click="accountNumberList" style="margin-left: 10px;">{{
            $t("message.inquire")
          }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 业务账号 -->
            <li>
              {{ $t("message.accountNumber") }}
            </li>
            <!-- 业务名称 -->
            <li>
              {{ $t("message.adminName") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}

            </li>
          </ol>
          <ul v-for="(item, index) in realnameList" :key="item.id">
            <!-- 客户ID -->
            <li>
              {{ item.username }}
            </li>
            <!-- 业务名称 -->
            <li>
              {{ item.realname }}
            </li>
            <!-- 操作 -->
            <li>
              <!-- 删除 -->
              <el-button type="danger" @click="realnameList.splice(index, 1)" size="mini">{{ $t("message.delete")
              }}</el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确认 -->
        <el-button type="primary" @click="confirmAdmin">{{
          $t("message.confirm")
        }}</el-button>

      </span>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {

      dialogVisible: false,
      type: "10",
      user: [],//客户列表
      admin: [],//业务员列表
      chooseCWGroupDialogVisible: false,//选择客户聊天群组弹窗
      clientID: "",//客户ID
      clientList: [],//客户列表
      chooseUserDialogVisible: false,//选择业务员弹窗
      realname: "",//业务员姓名
      realnameList: [],//业务员列表
    };
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.type = "10"
        this.user = []
        this.admin = []
      }
    }
  },
  methods: {


    // 选择客户聊天群组
    chooseCWGroupSave() {
      if (!this.clientID) {
        this.$message({
          message: this.$t("message.pleaseEnterClientID"),
          type: "warning",
        });
        return;
      }
      let datas = {
        id: this.clientID,
        page: 1,
        pageSize: 99,
      }
      this.$api.clienteleApi.clientList(datas).then((res) => {
        this.clientList = [...this.clientList, ...res.data.data];
        // 过滤重复客户
        this.clientList = this.clientList.filter((item, index, arr) => {
          return arr.findIndex((t) => t.id === item.id) === index;
        });
      });
    },
    // 选择客户聊天群组
    chooseCWGroup() {
      this.clientID = "";
      this.clientList = [];
      this.chooseCWGroupDialogVisible = true;
    },
    // 确认客户
    confirmUser() {
      if (this.clientList.length === 0) {
        this.$message({
          message: this.$t("message.pleaseChooseCustomer"),
          type: "warning",
        });
        return;
      }
      this.user = [...this.user, ...this.clientList];
      // 过滤重复客户
      this.user = this.user.filter((item, index, arr) => {
        return arr.findIndex((t) => t.id === item.id) === index;
      });
      this.chooseCWGroupDialogVisible = false;
    },
    // 选择人员
    chooseUser() {
      this.realname = "";
      this.realnameList = [];
      this.chooseUserDialogVisible = true;
    },
    // 查询业务员
    accountNumberList() {
      let datas = {
        realname: this.realname,
        page: 1,
        pageSize: 99,
      }
      this.$api.roleApi.accountNumberList(datas).then((res) => {
        this.realnameList = [...this.realnameList, ...res.data.data];
        // 过滤重复客户
        this.realnameList = this.realnameList.filter((item, index, arr) => {
          return arr.findIndex((t) => t.id === item.id) === index;
        });

      });
    },
    // 确认业务员
    confirmAdmin() {
      if (this.realnameList.length === 0) {
        this.$message({
          message: this.$t("message.pleaseChooseAdmin"),
          type: "warning",
        });
        return;
      }
      this.admin = [...this.admin, ...this.realnameList];
      // 过滤重复业务员
      this.admin = this.admin.filter((item, index, arr) => {
        return arr.findIndex((t) => t.id === item.id) === index;
      });
      this.chooseUserDialogVisible = false;
    },
    // 确认操作
    modifyingGroup() {
      if (this.user.length === 0) {
        this.$message({
          message: this.$t("message.pleaseChooseCustomer"),
          type: "warning",
        });
        return;
      }
      if (this.admin.length === 0) {
        this.$message({
          message: this.$t("message.pleaseChooseAdmin"),
          type: "warning",
        });
        return;
      }
      let datas = {
        type: this.type,
        personnel_type: 1,
        user: this.user.map((item) => item.id),
        admin_id: this.admin.map((item) => item.id),
      }

      this.$api.clienteleApi.modifyingGroup(datas).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: this.$t("message.operationSuccess"),
            type: "success",
          });
          this.dialogVisible = false;
        }
      });
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 00px;

  .row {
    display: flex;
    line-height: 40px;
    margin-bottom: 10px;

    .label {
      margin-right: 20px;
    }

    .value {
      flex: 1;
    }
  }

  .table {
    margin: 20px 0;
  }
}
</style>